import store from '../store';

export default {
    install(Vue) {
        // 性别
        Vue.filter('sex', (value) => {
            if (value === '1') {
                return '男';
            }
            if (value === '0') {
                return '女';
            }
            return '未知';
        });
        // 是否文案（Yes Or No）
        Vue.filter('YONText', (value) => {
            return value ? '是' : '否';
        });
        // 是否启用文案
        Vue.filter('enableText', (value) => {
            return value ? '启用' : '禁用';
        });
        // 是否禁用文案
        Vue.filter('disabledText', (value) => {
            return value ? '禁用' : '启用';
        });
        //数据主体
        Vue.filter('data_type', (value) => {
            const dictList = store.state.dictList;
            const list = dictList.find(
                (item) => item.code === 'data_type'
            )?.dictDataList||[];
            return list.find((item) => item.code === value) ? list.find((item) => item.code === value).label : '-';
        });
        //模板类型
        Vue.filter('template_type', (value) => {
            const dictList = store.state.dictList;
            const list = dictList.find(
                (item) => item.code === 'template_type'
            )?.dictDataList||[];
            return list.find((item) => item.code === value) ? list.find((item) => item.code === value).label : '-';
        });
        // Vue.filter('call_type', (value) => {
        //     const dictList = store.state.dictList;
        //     const list = dictList.find(
        //         (item) => item.code === 'call_type'
        //     ).dictDataList;
        //     return list.find((item) => item.code === value) ? list.find((item) => item.code === value).label : '-';
        // });
        // Vue.filter('call_key_feedback', (value) => {
        //     const dictList = store.state.dictList;
        //     const list = dictList.find(
        //         (item) => item.code === 'call_key_feedback'
        //     ).dictDataList;
        //     return list.find((item) => item.code === value) ? list.find((item) => item.code === value).label : '-';
        // });
        // Vue.filter('con_linkman_business_type', (value) => {
        //     const dictList = store.state.dictList;
        //     const list = dictList.find(
        //         (item) => item.code === 'con_linkman_business_type'
        //     ).dictDataList;
        //     return list.find((item) => item.code === value) ? list.find((item) => item.code === value).label : '-';
        // });
        // Vue.filter('con_linkman_project_type', (value) => {
        //     const dictList = store.state.dictList;
        //     const list = dictList.find(
        //         (item) => item.code === 'con_linkman_project_type'
        //     ).dictDataList;
        //    return (value&&value.map(itemOne=>{
        //         return list.find((item) => item.code === itemOne) ? list.find((item) => item.code === itemOne).label : '-';
        //     }).join(','))||'-';
        // });
    },
};
